@if (!isNakedView()) {
<oke-header id="app-header" />
} @if (storageSvc.currentAccount$ | async; as account) {
<oke-sidebar id="app-sidebar" class="app-sidebar" />
}
<main class="app-main" id="app-main">
  @if (backgroundImage$ | async; as bgImgSrc) {
  <figure id="app-main-bg-figure" class="bg--app-main treated">
    <img alt="Image at/of ONEOK asset" class="bg-img--app-main" [src]="bgImgSrc" />
  </figure>
  }
  <router-outlet (activate)="onActivate($event)" />
  @if (!isNakedView()) {
  <div class="justify-content-center text-center">
    <oke-loader [loadId]="$loadId()" />
  </div>
  }
</main>

<!-- Site-wide Notifications via Strapi -->
@if( strapiSvc.notifications?.length > 1 ){
<div class="notifications-container">
  @for( notification of strapiSvc.notifications; track notification.id; let notificationIdx = $index; let
  numNotifications = $count ){ @if( isNotificationVisible( notification ) ){
  <oke-notification
    class="notification"
    [notification]="notification"
    [attr.data-idx]="notificationIdx"
    [attr.data-id]="notification.id"
    [attr.style]="'--layer-idx:'+math.abs( notificationIdx + 1 - numNotifications )"
    (clear)="onNotificationAcknowledged($event)"
  />
  } }
</div>
} @else if( strapiSvc.notifications?.length === 1 && isNotificationVisible( strapiSvc.notifications[0] ) ){
<oke-notification
  class="notification"
  [notification]="strapiSvc.notifications[0]"
  [attr.data-id]="strapiSvc.notifications[0].id"
  (clear)="onNotificationAcknowledged($event)"
/>
}

<!-- New-user "Card(s)" via Strapi -->
@if (strapiSvc.orientations) { @for (orientation of strapiSvc.orientations; track orientation; let orientationIdx =
$index) { @if (isOrientationVisible( orientation )) {
<oke-orientation
  class="orientation-card"
  [content]="orientation"
  [attr.data-idx]="orientationIdx"
  [attr.data-id]="orientation.id"
  (clear)="onOrientationAcknowledged( $event )"
/>
} } }
